document.addEventListener("DOMContentLoaded", function () {
  const allowedCharacters = /^[A-Za-z0-9äöüÄÖÜ.,:;\-_+*&@%#"\/()?\séèêëàâùûçîïôœ]$/;
  function sanitizeInput(event) {
    if (event.target && event.target.classList.contains("gpo-input")) {
      const inputField = event.target;
      const sanitizedValue = Array.from(inputField.value)
        .filter((char) => allowedCharacters.test(char))
        .join("");
      if (inputField.value !== sanitizedValue) {
        inputField.value = sanitizedValue;
      }
    }
  }
  document.addEventListener("input", sanitizeInput);
});